// PartnerCard.js
import React from "react";
import { UserBadges } from "../BadgePill";

export default function PartnerCard({ partner, onLike, onPass, disabled }) {
  if (!partner) {
    return (
      <div className="mt-6 rounded-2xl border border-dashed border-white/20 p-6 text-center bg-black/20">
        <p className="text-sm sm:text-base text-white/70">
          You're sitting this round out. New match coming next round. ✨
        </p>
      </div>
    );
  }

  return (
    <div className="mt-6 flex flex-col items-center gap-4">
      <div className="w-full max-w-md rounded-3xl bg-black/70 border border-white/10 p-4 sm:p-6 shadow-xl">
        <div className="flex items-center gap-4">
          <div className="relative w-16 h-16 sm:w-20 sm:h-20 rounded-2xl overflow-hidden border border-white/10">
            {partner.primaryPhotoUrl ? (
              <img
                src={partner.primaryPhotoUrl}
                alt={partner.name}
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-pink-500/30 to-purple-500/30 text-xl sm:text-2xl">
                {partner.name?.[0] ?? "?"}
              </div>
            )}
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-2 flex-wrap">
              <h2 className="text-lg sm:text-xl font-semibold text-white">
                {partner.name || "Mystery Match"}
              </h2>
              {partner.age && (
                <span className="text-sm text-white/70">{partner.age}</span>
              )}
            </div>
            {/* User badges (Inner Circle, Elite, Verified) */}
            <UserBadges user={partner} size="xs" className="mt-1" />
            {partner.city && (
              <p className="text-xs sm:text-sm text-white/60 mt-1">
                {partner.city}, {partner.countryCode}
              </p>
            )}
          </div>
        </div>
        {partner.bio && (
          <p className="mt-4 text-sm text-white/75 line-clamp-3">
            {partner.bio}
          </p>
        )}
        <div className="mt-4 flex flex-wrap gap-2">
          {partner.tags?.map((tag) => (
            <span
              key={tag}
              className="inline-flex items-center px-2.5 py-1 rounded-full text-xs bg-white/5 text-white/70 border border-white/10"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>

      <div className="flex gap-4 mt-2">
        <button
          type="button"
          onClick={onPass}
          disabled={disabled}
          className="px-6 py-2 rounded-full border border-white/20 text-sm sm:text-base text-white/80 bg-black/40 hover:bg-black/60 disabled:opacity-50"
        >
          ✋ Pass
        </button>
        <button
          type="button"
          onClick={onLike}
          disabled={disabled}
          className="px-6 py-2 rounded-full text-sm sm:text-base font-semibold bg-gradient-to-r from-pink-500 to-purple-500 text-white shadow-lg shadow-pink-500/30 hover:brightness-110 disabled:opacity-50"
        >
          💜 I'm Interested
        </button>
      </div>
    </div>
  );
}